const PRODUCTS_URL = process.env.API_URL + '/xugarhero/shop/product';

const getProducts = (context, durationFilter) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PRODUCTS_URL, {params: {durationFilter}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getProducts
};



// WEBPACK FOOTER //
// ./src/brand/health/api/products/index.js